<script setup>

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24 id="page-about">
    <div class="about-warp__right--title">{{ $t('fdgmgapp') }}</div>
    <div class="about-warp__right--content app-box">
      <p>
        {{
          $t('fdgmgappyfdxgmgszdyfsykjkhjyhqzxzbspddgnyytdzhfwxjyappfdgmgappcpnrqzwjtymbjyhhrtzxgnsgprmgmgjjddccfzjykc')
        }}</p>
      <p style="font-weight: 600;margin: 8px 0;text-indent: 0;color: #1D2228;">{{ $t('fdzqjyrj-aqkkczjb') }}</p>
      <p style="font-weight: 600;margin: 8px 0;color: #1D2228;">{{ $t('zjcyscddzdxgjys') }}</p>
      <p>{{ $t('sykhddbczyzhtjzkzhsdgpyzzsjyswrhtcddyyalyhcdnfhfwgnjssp') }}</p>

      <p style="font-weight: 600;margin: 8px 0;color: #1D2228;">{{ $t('zjtrbzsshqjgsjaq') }}</p>
     <p>{{ $t('zzzzzzz') }}</p>

      <p style="font-weight: 600;margin: 8px 0;color: #1D2228;">{{ $t('dysjsdzxznkszjsy') }}</p>
      <p>{{ $t('fdzqycxasdkltdzmsjssdhzc1000mkhgxzxcsdysjwnsdgltzxwggdzxfdzqyjsdckhfwtxdjzxwntzjsdy') }}</p>

      <p style="font-weight: 600;margin: 8px 0;color: #1D2228;">{{ $t('fdxgmgszdyfwkhjjsndzjzrj') }}</p>
      <p> · {{ $t('qptzcmzglkhmacoswindowsandroidios') }}</p> <br>
      <p> · {{ $t('qldzfdxtc0d1ksrmgmgs') }}</p><br>
      <p> · {{ $t('jyzxsqzjdhhlgs') }}</p>

    <!--  <p style="font-weight: 600;margin: 8px 0;text-indent: 0;">{{ $t('zskf') }}</p>
      <p> · {{ $t('ckhdrjqc1d1gjfw900-2400zsjzx') }}</p>
      <p> · {{ $t('zbchxzxsblhmyhkzcdlkjwkrj') }}</p>
      <p> · {{ $t('wxdhappddzqdbcckgtshsd') }}</p>
      <p> · {{ $t('yzxgtgyyrzedfwzgkx20bgg') }}</p> -->
    </div>
    <div class="about-warp__right--appimg">
      <img src="https://tg.fdzq.com/img/forthright-sec/images/about/app.png"/>
    </div>
  </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
@media screen and (max-width: 420px) {
  body {
    #page-about {
      .about-warp__right--appimg {
        padding: 0 15px;

        img {
          width: 100%;
          padding: 0;
          margin: 20px 0 0;
        }
      }
    }
  }
}

#page-about {
  .app-box {
    color: #61676B;
    // text-indent: 2em;
    .font-size-line(14, 20);

    //& > p:nth-child(2) {
    //  margin-bottom: 15px;
    //}

    .app-box--features {

    }
  }

  .about-warp__right--appimg {
    text-align: center;

    img {
      width: 506px;
      margin: 40px 40px 60px;
    }
  }
}
</style>
